export default __webpack_public_path__ + "static/media/logoFooter.4c0d7e17.svg";